module.exports = __webpack_public_path__ + "assets/icon_s2p_ult.15a05948.svg";